var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAiHigh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.125 0.75H18.125C18.4375 0.75 18.75 1.0625 18.75 1.375C18.75 1.72656 18.4375 2 18.125 2H3.125C2.07031 2 1.25 2.85938 1.25 3.875V15.125C1.25 16.1797 2.07031 17 3.125 17H16.875C17.8906 17 18.75 16.1797 18.75 15.125V6.375C18.75 5.35938 17.8906 4.5 16.875 4.5H4.375C4.02344 4.5 3.75 4.22656 3.75 3.875C3.75 3.5625 4.02344 3.25 4.375 3.25H16.875C18.5938 3.25 20 4.65625 20 6.375V15.125C20 16.8828 18.5938 18.25 16.875 18.25H3.125C1.36719 18.25 0 16.8828 0 15.125V3.875C0 2.15625 1.36719 0.75 3.125 0.75ZM15 11.6875C14.4531 11.6875 14.0625 11.2969 14.0625 10.75C14.0625 10.2422 14.4531 9.8125 15 9.8125C15.5078 9.8125 15.9375 10.2422 15.9375 10.75C15.9375 11.2969 15.5078 11.6875 15 11.6875Z",
    fill: "#8791B4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAiHigh);
export default __webpack_public_path__ + "static/media/icon-ai-high.ac20576b2050a0f36ad56e59acd3cec7.svg";
export { ForwardRef as ReactComponent };